import { createFileRoute } from '@tanstack/react-router';
import { ArticlePath, createGuideLink } from '@mews-commander/enums';
import { prefetchRebateForm, RebateBillContainer } from '@mews-commander/modules/src/modules/billing';
import { MewsTeam, RouteType } from '@mews/enums';

const Component = () => (
    <RebateBillContainer billId={Route.useParams().id} guideLink={createGuideLink(ArticlePath.CorrectingClosedBill)} />
);

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Bill/Rebate/$id')({
    beforeLoad: ({ context: { checkPrivilege } }) => {
        checkPrivilege('rebateItems');
    },
    component: Component,
    loader: async ({
        context: {
            dispatch__DO_NOT_USE_OR_YOU_WILL_BE_FIRED: dispatch,
            getState__DO_NOT_USE_OR_YOU_WILL_BE_FIRED: getState,
        },
        params,
    }) => {
        await prefetchRebateForm(dispatch, getState, params.id);
    },
    staticData: {
        owner: MewsTeam.Billing,
        type: RouteType.Frontend,
    },
});
